//To add screen reader text to the title attr when a link is set to open a new window

jQuery( document ).ready( function( $ ) {

	function init() {
		console.log('JTF External Links V1.1');
        //Find ALL links on a page that are set to open a new window
        if ( $( 'a[target="_blank"]' ) ) {
            //store the links
            var blank_links = $( 'a[target="_blank"]' );
            //the text to be added to the title attr
            var new_text = 'opens a new window';

            //now loop through all links found
            $( blank_links ).each( function () {
                if ( $( this ).attr( 'title' ) ) { // $() | $(this)
                    //if a title attr exists get the attr, store it and then add the new_text to it

                    var old_title = $( this ).attr( 'title' );
                    var new_title =  old_title + ' ' + new_text;

                    $( this ).attr( 'title', new_title );
                } else {
                    //if a title attr doesn't exist, create one
                    $( this ).attr( 'title', new_text );
                }
            })
        }
    }
	// Set delay so that Yoast can load, before executing the code
	setTimeout(
		function() {
			init();
		},
		2000
	);
});


